import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import api from "@/lib/api";

const fmtWhen = (ts) => (ts ? new Date(ts.endsWith?.("Z") || ts.includes?.("+") ? ts : `${ts}Z`).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export function ItemMasterSyncButton() {
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/items/item-master/status").then(({ data }) => setInfo(data)).catch(() => {}); }, []);
  const sync = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/items/item-master/sync", {}, { timeout: 90000 });
      setInfo(data);
      toast.success(`Item master synced · ${Number(data.count || 0).toLocaleString("en-IN")} items${data.skipped ? " (just refreshed)" : ""}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Item master sync failed");
    } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={sync} disabled={busy} data-testid="item-master-sync-btn"
      title={`Pull new items from ERP Item table · last synced ${fmtWhen(info?.synced_at)}`}
      className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-sm border border-white/25 bg-white/10 hover:bg-white/20 text-white text-xs transition-colors disabled:opacity-60">
      <RefreshCw size={13} className={busy ? "animate-spin" : ""} />
      <span className="hidden sm:inline">{busy ? "Syncing items…" : "Sync items"}</span>
      {info?.synced_at && !busy && <span className="hidden md:inline text-cyan-100" data-testid="item-master-last-sync">· {fmtWhen(info.synced_at)}</span>}
    </button>
  );
}
